export const ENVIRONMENT = process.env.NODE_ENV === "production" ? "prod" : "dev";
export const BACKEND_URL = ENVIRONMENT === "prod" ? "https://api.defibrion.nl" : "http://localhost:65080";
export const PORTAL_URL = ENVIRONMENT === "prod" ? "https://mijn.defibrion.nl" : "http://localhost:5174";
export const SENTRY_DSN = "https://1b084eb7ff8342bf9240266a58296817@o81216.ingest.sentry.io/4504158465556480";
export const GOOGLE_MAPS_API_KEY = "AIzaSyCit3mgRbGiroWg8n1cR4bXdzd5LM07_5k";
export const GOOGLE_MAPS_MAP_ID = "982f4cdf5ad2635e";
